<div>
  <p-dialog header="Add payment received" [modal]="true" [(visible)]="bookingTransactionsService.creatingPaymentReceived">
    <app-create-payment-received (newPaymentReceived)="bookingTransactionsService.updateTransactions()"
      *ngIf="bookingTransactionsService.creatingPaymentReceived"></app-create-payment-received>
  </p-dialog>
  <p-dialog header="Edit payment" [modal]="true" [(visible)]="bookingTransactionsService.editingPaymentReceived">
    <app-edit-payment-received (newPaymentReceived)="bookingTransactionsService.updateTransactions()"
      *ngIf="bookingTransactionsService.editingPaymentReceived"></app-edit-payment-received>
  </p-dialog>
  <p-dialog header="Add new invoice" [modal]="true" [(visible)]="bookingTransactionsService.creatingSchoolInvoice">
    <app-create-school-invoice (newInvoiceEvent)="addSchoolInvoice($event)"
      *ngIf="bookingTransactionsService.creatingSchoolInvoice">
    </app-create-school-invoice>
  </p-dialog>
  <p-dialog header="Edit invoice" [modal]="true" [(visible)]="bookingTransactionsService.editingSchoolInvoice">
    <app-edit-school-invoice (newInvoiceEvent)="addSchoolInvoice($event)"
      *ngIf="bookingTransactionsService.editingSchoolInvoice">
    </app-edit-school-invoice>
  </p-dialog>
  <p-dialog header="Add payment to supplier" [modal]="true"
    [(visible)]="bookingTransactionsService.creatingPaymentToSupplier">
    <app-create-payment-to-supplier (newSchoolPaymentEvent)="updateSchoolPayments()"
      *ngIf="bookingTransactionsService.creatingPaymentToSupplier"></app-create-payment-to-supplier>
  </p-dialog>
  <p-dialog header="Edit payment" [modal]="true" [(visible)]="bookingTransactionsService.editingPaymentToSupplier">
    <app-edit-payment-to-supplier (newSchoolPaymentEvent)="updateSchoolPayments()"
      *ngIf="bookingTransactionsService.editingPaymentToSupplier"></app-edit-payment-to-supplier>
  </p-dialog>
  <p-dialog header="Upload invoice (Max. 16MB)" [modal]="true"
    [(visible)]="bookingTransactionsService.creatingSchoolInvoiceFile">
    <app-edit-school-invoice-file [schoolInvoice]="selectedInvoice!" (fileUploadEvent)="updateFileUploader($event)"
      *ngIf="bookingTransactionsService.creatingSchoolInvoiceFile"></app-edit-school-invoice-file>
  </p-dialog>
  <p-dialog header="Vivawallet Payment Orders" [modal]="true" [(visible)]="showVivawalletOrdersView">
    <app-vivawallet-payment-orders *ngIf="showVivawalletOrdersView"></app-vivawallet-payment-orders>
  </p-dialog>
  <div class="transactions-container">
    <div class="balances-container" *ngIf="bookingTransactionsService.financialState && bookingTransactionsService.financialStateType == 'EUROPE'">
      <div class="recap-left-container">
        <div class="title-container">
          <h3 class="title">
            Recap
          </h3>
        </div>
        <div [formGroup]="bookingDatesForm" class="date-form-container" *ngIf="bookingDatesForm">
          <div>
            <p>
              Deposit received
            </p>
            <input pInputText [value]="bookingService.booking.depositReceived?.toDate() | date:'dd/MM/yyyy'" readonly>
          </div>
        </div>
        <div class="total-balance-container">
          <div>
            <p>
              Total received(€)
            </p>
            <div>
              <input pInputText [value]="bookingTransactionsService.financialState.totalReceivedInEuro" readonly>
            </div>
          </div>
          <div>
            <p>
              Balance(€)
            </p>
            <div>
              <input pInputText [value]="bookingTransactionsService.financialState.balanceInEuro" readonly>
            </div>
          </div>
          <div>
            <p>
              Balance({{bookingPreConfirmationService.preConfirmationForm.get("baseCurrency")!.value.isoCode}})
            </p>
            <div>
              <input pInputText [value]="bookingTransactionsService.financialState.balanceInBaseCurrency" readonly>
            </div>
          </div>
        </div>
        <div class="total-balance-container">
          <div>
            <p>
              School Invoice(€)
            </p>
            <div>
              <input pInputText [value]="bookingTransactionsService.financialState.totalInvoiceInEuro" readonly>
            </div>
          </div>
          <div>
            <p>
              Margin(€)
            </p>
            <div>
              <input pInputText [value]="bookingTransactionsService.financialState.marginInEuro" readonly>
            </div>
          </div>
          <div>
            <p>
              Balance to school(€)
            </p>
            <div>
              <input pInputText [value]="bookingTransactionsService.financialState.balanceToSchoolInEuro" readonly>
            </div>
          </div>
        </div>
      </div>

      <div class="vivawallet-orders-button-container">
        <p-button label="Vivawallet Orders History" (onClick)="activateVivawalletOrdersView()" [disabled]="paymentOrders.length==0"></p-button>
      </div>
    </div>
    <div class="balances-container" *ngIf="bookingTransactionsService.brazilianFinancialState && bookingTransactionsService.financialStateType == 'BRAZIL'">
      <div class="recap-left-container">
        <div class="title-container">
          <h3 class="title">
            Recap
          </h3>
        </div>
        <div [formGroup]="bookingDatesForm" class="date-form-container" *ngIf="bookingDatesForm">
          <div>
            <p>
              Deposit received
            </p>
            <input pInputText [value]="bookingService.booking.depositReceived?.toDate() | date:'dd/MM/yyyy'" readonly>
          </div>
        </div>
        <div class="total-balance-container">
          <div>
            <p>
              Total received(R$)
            </p>
            <div>
              <input pInputText [value]="bookingTransactionsService.brazilianFinancialState.totalReceivedInReal" readonly>
            </div>
          </div>
          <div>
            <p>
              Balance(R$)
            </p>
            <div>
              <input pInputText [value]="bookingTransactionsService.brazilianFinancialState.balanceInReal" readonly>
            </div>
          </div>
          <div>
            <p>
              Balance({{bookingPreConfirmationService.preConfirmationForm.get("baseCurrency")!.value.isoCode}})
            </p>
            <div>
              <input pInputText [value]="bookingTransactionsService.brazilianFinancialState.balanceInBaseCurrency" readonly>
            </div>
          </div>
        </div>
        <div class="total-balance-container">
          <div>
            <p>
              School Invoice(R$)
            </p>
            <div>
              <input pInputText [value]="bookingTransactionsService.brazilianFinancialState.totalInvoiceInReal" readonly>
            </div>
          </div>
          <div>
            <p>
              Margin(R$)
            </p>
            <div>
              <input pInputText [value]="bookingTransactionsService.brazilianFinancialState.marginInReal" readonly>
            </div>
          </div>
          <div>
            <p>
              Balance to school(R$)
            </p>
            <div>
              <input pInputText [value]="bookingTransactionsService.brazilianFinancialState.balanceToSchoolInReal" readonly>
            </div>
          </div>
        </div>
      </div>

      <div class="vivawallet-orders-button-container">
        <p-button label="Vivawallet Orders History" (onClick)="activateVivawalletOrdersView()" [disabled]="paymentOrders.length==0"></p-button>
      </div>
    </div>

    <div class="payment-received-container">
      <h3 class="title">
        Payment from customer
      </h3>
      <div class="transaction-table-container">
        <p-table [value]="paymentReceivedService.payments" class="transaction-table">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 50px;">#</th>
              <th style="width: 180px;">Invoice number</th>
              <th>Date</th>
              <th>Amt</th>
              <th>Currency</th>
              <th>Euro</th>
              <th style="width: 180px;">Means of Payment</th>
              <th style="width: 200px;">Comment</th>
              <th style="width: 50px;">Info</th>
              <th style="width: 100px;"> Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-paymentReceived let-i="rowIndex">
            <tr class="table-row" (mouseenter)="mouseoverPaymentReceived(paymentReceived)"
              (mouseleave)="mouseoutPaymentReceived(paymentReceived)">
              <td>
                {{i+1}}
              </td>
              <td (click)="editPaymentReceived(paymentReceived)">
                {{paymentReceived.invoiceNumber | shortStr: '20'}}
              </td>
              <td (click)="editPaymentReceived(paymentReceived)">
                {{paymentReceived.date | date:'dd/MM/yyyy'}}
              </td>
              <td (click)="editPaymentReceived(paymentReceived)">
                {{paymentReceived.amount | decimalAmount}}
              </td>
              <td (click)="editPaymentReceived(paymentReceived)">
                {{paymentReceived.currency.isoCode}}
              </td>
              <td (click)="editPaymentReceived(paymentReceived)">
                {{paymentReceived.amountInEuro | decimalAmount}}
              </td>
              <td (click)="editPaymentReceived(paymentReceived)">
                {{paymentReceived.paymentType.name}}
              </td>
              <td (click)="editPaymentReceived(paymentReceived)">
                {{paymentReceived.comment | shortStr: '20'}}
              </td>
              <td>
                <i *ngIf="paymentReceived.created" class="pi pi-info-circle" tooltipPosition="top"
                  [pTooltip]="'created: ' + paymentReceived.created.format('DD/MM/YYYY') + '\n created by: ' + paymentReceived.createdBy.name"></i>
              </td>
              <td>
                <table class="hover-menu">
                  <tr>
                    <td>
                      <div class="icon-container">
                        <i class="pi pi-pencil" (click)="editPaymentReceived(paymentReceived)"></i>
                      </div>
                    </td>
                    <td>
                      <div class="icon-container">
                        <i class="pi pi-times-circle" (click)="removePaymentReceived(paymentReceived)"></i>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr class="no-record-tr" *ngIf="paymentReceivedService.payments.length > 0">
              <td colspan="10">
                <div class="no-record-row" (click)="addPaymentReceived()">
                  <p class="no-record-message">
                    Add record
                  </p>
                  <div class="icon-wrap">
                    <i class="pi pi-plus"></i>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="no-record-tr">
              <td colspan="10">
                <div class="no-record-row" (click)="addPaymentReceived()">
                  <p class="no-record-message">
                    No record
                  </p>
                  <div class="icon-wrap">
                    <i class="pi pi-plus"></i>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <div class="school-invoice-container">
      <h3 class="title">
        Invoice from school
      </h3>
      <div class="transaction-table-container">
        <p-table [value]="schoolInvoiceService.invoices">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 50px;">#</th>
              <th style="width: 160px;">Invoice number</th>
              <th>Date</th>
              <th style="width: 110px;">Amt</th>
              <th>Due date</th>
              <th>Currency</th>
              <th>Euro</th>
              <th style="width: 170px;">Means of Payment</th>
              <th style="width: 180px;">Comment</th>
              <th style="width: 50px;">Info</th>
              <th>Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-schoolInvoice let-j="rowIndex">
            <tr (mouseenter)="mouseoverSchoolInvoice(schoolInvoice)"
              (mouseleave)="mouseoutSchoolInvoice(schoolInvoice)">
              <td>{{j+1}}</td>
              <td (click)="editSchoolInvoice(schoolInvoice)">
                {{schoolInvoice.invoiceNumber | shortStr: '18'}}
              </td>
              <td (click)="editSchoolInvoice(schoolInvoice)">
                {{schoolInvoice.date | date:'dd/MM/yyyy'}}
              </td>
              <td (click)="editSchoolInvoice(schoolInvoice)">
                <span *ngIf="schoolInvoice.isValid">
                  {{schoolInvoice.amount | decimalAmount}}
                </span>
                <span *ngIf="!schoolInvoice.isValid">
                  Not ready
                </span>
              </td>
              <td (click)="editSchoolInvoice(schoolInvoice)">
                <p *ngIf="schoolInvoice.dueDate">
                  {{schoolInvoice.dueDate | date:'dd/MM/yyyy'}}
                </p>
                <p *ngIf="!schoolInvoice.dueDate">
                  {{schoolInvoice.paymentOrders[0].dueDate | date:'dd/MM/yyyy'}}
                </p>
              </td>
              <td (click)="editSchoolInvoice(schoolInvoice)">
                {{schoolInvoice.currency.isoCode}}
              </td>
              <td (click)="editSchoolInvoice(schoolInvoice)">
                <span *ngIf="schoolInvoice.isValid">
                  {{schoolInvoice.amountInEuro | decimalAmount}}
                </span>
              </td>
              <td (click)="editSchoolInvoice(schoolInvoice)">
                {{schoolInvoice.paymentType.name}}
              <td (click)="editSchoolInvoice(schoolInvoice)">
                {{schoolInvoice.comment | shortStr: '18'}}
              </td>
              <td>
                <i *ngIf="schoolInvoice.created" class="pi pi-info-circle" tooltipPosition="top"
                  [pTooltip]="'created: ' + schoolInvoice.created.format('DD/MM/YYYY') + '\n created by: ' + schoolInvoice.createdBy.name"></i>
              </td>
              <td class="menu-head">
                <table class="hover-menu">
                  <tr>
                    <td>
                      <div class="icon-container">
                        <i class="pi pi-upload" (click)="activateInvoiceFileUpload(schoolInvoice)"
                          *ngIf="!schoolInvoice.fileId"></i>
                        <i class="pi pi-file-pdf" (click)="downloadInvoiceFile(schoolInvoice)"
                          *ngIf="schoolInvoice.fileId"></i>
                      </div>
                    </td>
                    <td *ngIf="schoolInvoice.fileId">
                      <div class="icon-container">
                        <i class="pi pi-refresh" (click)="activateInvoiceFileUpload(schoolInvoice)"></i>
                      </div>
                    </td>
                    <td>
                      <div class="icon-container">
                        <i class="pi pi-pencil" (click)="editSchoolInvoice(schoolInvoice)"></i>
                      </div>
                    </td>
                    <td>
                      <div class="icon-container">
                        <i class="pi pi-times-circle" (click)="removeSchoolInvoice(schoolInvoice)"></i>
                      </div>
                    </td>
                    <td *ngIf="hasMultiplePaymentOrders">
                      <div class="icon-container">
                        <i class="pi pi-eye-slash" (click)="showPaymentOrders()" *ngIf="canShowPaymentOrders"></i>
                        <i class="pi pi-eye" (click)="showPaymentOrders()" *ngIf="!canShowPaymentOrders"></i>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <ng-container *ngIf="canShowPaymentOrders && schoolInvoice.paymentOrders.length > 1">
              <tr *ngFor="let order of schoolInvoice.paymentOrders; let k = index">
                <td>{{j+1}}</td>
                <td>Payment order {{k+1}}</td>
                <td></td>
                <td>{{order.amount}}</td>
                <td>{{order.dueDate | date: 'dd/MM/yyyy'}}</td>
                <td>{{order.currency.isoCode}}</td>
                <td>{{order.amountInEuro}}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </ng-container>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="no-record-tr">
              <td colspan="11">
                <div class="no-record-row" (click)="createtSchoolInvoice()">
                  <p class="no-record-message">
                    No record
                  </p>
                  <div class="icon-wrap">
                    <i class="pi pi-plus"></i>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr class="no-record-tr" *ngIf="schoolInvoiceService.invoices.length > 0">
              <td colspan="11">
                <div class="no-record-row" (click)="createtSchoolInvoice()">
                  <p class="no-record-message">
                    Add record
                  </p>
                  <div class="icon-wrap">
                    <i class="pi pi-plus"></i>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <div class="payment-to-supplier-container">
      <h3 class="title">
        Payment to school
      </h3>
      <div class="transaction-table-container">
        <p-table [value]="paymentToSupplierService.payments" class="transaction-table">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 50px;">#</th>
              <th style="width: 180px;">Invoice number</th>
              <th>Date</th>
              <th>Amt</th>
              <th>Currency</th>
              <th>Euro</th>
              <th style="width: 180px;">Means of Payment</th>
              <th style="width: 180px;">Comment</th>
              <th style="width: 50px;">Info</th>
              <th style="width: 100px;">Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-paymentToSupplier let-k="rowIndex">
            <tr class="table-row" (mouseenter)="mouseoverPaymentToSupplier(paymentToSupplier)"
              (mouseleave)="mouseoutPaymentToSupplier(paymentToSupplier)">
              <td>
                {{k+1}}
              </td>
              <td (click)="editPaymentToSupplier(paymentToSupplier)" *ngIf="paymentToSupplier.paidOrder">
                {{paymentToSupplier.paidInvoice.invoiceNumber | shortStr: '18'}}
              </td>
              <td (click)="editPaymentToSupplier(paymentToSupplier)">
                {{paymentToSupplier.date | date:'dd/MM/yyyy'}}
              </td>
              <td (click)="editPaymentToSupplier(paymentToSupplier)">
                {{paymentToSupplier.amount | decimalAmount}}
              </td>
              <td (click)="editPaymentToSupplier(paymentToSupplier)">
                {{paymentToSupplier.currency.isoCode}}
              </td>
              <td (click)="editPaymentToSupplier(paymentToSupplier)">
                {{paymentToSupplier.amountInEuro | decimalAmount}}
              </td>
              <td (click)="editPaymentToSupplier(paymentToSupplier)">
                {{paymentToSupplier.paymentType.name}}
              </td>
              <td (click)="editPaymentToSupplier(paymentToSupplier)">
                {{paymentToSupplier.comment | shortStr: '18'}}
              </td>
              <td>
                <i *ngIf="paymentToSupplier.created" class="pi pi-info-circle" tooltipPosition="top"
                  [pTooltip]="'created: ' + paymentToSupplier.created.format('DD/MM/YYYY') + '\n created by: ' + paymentToSupplier.createdBy.name"></i>
              </td>
              <td>
                <table class="hover-menu">
                  <tr>
                    <td>
                      <div class="icon-container">
                        <i class="pi pi-pencil" (click)="editPaymentToSupplier(paymentToSupplier)"></i>
                      </div>
                    </td>
                    <td>
                      <div class="icon-container">
                        <i class="pi pi-times-circle" (click)="removePaymentToSupplier(paymentToSupplier)"></i>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="no-record-tr">
              <td colspan="10">
                <div class="no-record-row" (click)="addPaymentToSupplier()">
                  <p class="no-record-message">
                    No record
                  </p>
                  <div class="icon-wrap">
                    <i class="pi pi-plus"></i>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr class="no-record-tr" *ngIf="paymentToSupplierService.payments.length > 0">
              <td colspan="10">
                <div class="no-record-row" (click)="addPaymentToSupplier()">
                  <p class="no-record-message">
                    Add record
                  </p>
                  <div class="icon-wrap">
                    <i class="pi pi-plus"></i>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>